import Vue    from 'vue';
import Vuex   from 'vuex';
import Common from '@/utils/common.js';
import {
	SET_ALL_GAMES,
	UPDATE_GAME_ICON,
	NAV_IS_PAGE_SCROLL,
	DEMO_DIALOG_IS_SHOW,
	FORM_DIALOG_IS_SHOW,
	CURRENT_GAME_ID,
	MOBILE_MENU_FLAG,
	CACHE_KEY,
	CACHE_EXPIRE
} from '@/type/mutation';
import {
	gameInfosNew
} from '@/api/gameInfosApi';

Vue.use(Vuex);

// 创建 Vuex 实例
export default new Vuex.Store({
	state: {
		allGames        : [],   // 全局共享的游戏数据

		currentGameId   : 0,    // 当前游戏ID
		isNavBgColorful : false,// 顶部导航栏状态：是否有背景色：true-有背景色（页面滚动时）、false无背景色、透明（页面未滚动时）默认；
		isShowDemoDialog: false,// DEMO弹窗状态：true-弹出、false-隐藏（默认）；
		isShowFormDialog: false,// FORM弹窗状态：true-弹出、false-隐藏（默认）；
		isShowMobileMenu: false,// 移动端菜单状态：true-弹出、false-隐藏（默认）；
		isHideForTest   : true  // 网站中部分模块临时隐藏：true-显示、false-隐藏（默认）
	},

	getters: {

	},

	mutations: {
		[SET_ALL_GAMES](state, games) {
			state.allGames = games;
		},

		[UPDATE_GAME_ICON](state, { gameId, icon }) {
			const game = state.allGames.find(game => game.game_id === gameId);
			if (game) {
				game.icon = icon;
			}
		},

		/**
		 * 游戏详情 - GameId
		 * 暂未启用
		 */
		[CURRENT_GAME_ID](state, data) {
			// console.log('=== store__index.js__mutations:CURRENT_GAME_ID >>>');
			state.currentGameId = data;
		},

		/**
		 * 唯一修改状态的位置
		 * 当页面向下滚动时，顶部导航栏背景变不透明
		 * Come From HomeView.vue mounted()
		 */
		[NAV_IS_PAGE_SCROLL](state, data) {
			// console.log('=== store__index.js__mutations:NAV_IS_PAGE_SCROLL >>>');
			state.isNavBgColorful = data;
		},

		/**
		 * DEMO弹窗状态
		 */
		[DEMO_DIALOG_IS_SHOW](state, data) {
			// console.log('=== store__index.js__mutations:DEMO_DIALOG_IS_SHOW >>>');
			state.isShowDemoDialog = data;
		},

		/**
		 * FORM弹窗状态
		 */
		[FORM_DIALOG_IS_SHOW](state, data) {
			// console.log('=== store__index.js__mutations:FORM_DIALOG_IS_SHOW >>>');
			state.isShowFormDialog = data;
		},

		/**
		 * 移动端菜单状态
		 */
		[MOBILE_MENU_FLAG](state, data) {
			state.isShowMobileMenu = data;
		}
	},

	actions: {
		async fetchGameDatas({ commit }) {
			// 1. 先从 localStorage 恢复（如果有）
			const cachedData = Common.getCache(CACHE_KEY, CACHE_EXPIRE);
			if(cachedData)
			{
				commit(SET_ALL_GAMES, cachedData);
			}

			// 2. 再去请求接口
			try {
				const res = await gameInfosNew();
				if(res && res.errCode === 0)
				{
					// console.log('=== App__mounted__store__index__fetchGameDatas__res >>>', JSON.stringify(res));
					// console.log('=== App__mounted__store__index__fetchGameDatas__res >>>', res);

					let _resDatas = res.data || [];

					// console.log('###数组类型:', Array.isArray(_resDatas), '长度:', _resDatas.length);
					// console.log('###第一个元素:', _resDatas[0]);
					commit(SET_ALL_GAMES, _resDatas);
					Common.setCache(CACHE_KEY, _resDatas);// 更新缓存
				}
				else
				{
					console.error('=== App__mounted__store__index__fetchGameDatas__获取游戏信息失败 >>>', res?.errMsg || '未知错误');
					return;
				}
			}
			catch(err) {
				console.error('=== App__mounted__store__index__fetchGameDatas__API请求失败 >>>', err);
				return;
			}
		}
	},

	modules: {
		
	}
});
